module.exports = __webpack_public_path__ + "static/media/remixicon.37364e27.ttf";